import { Config } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
const {
  t,
  tf
} = I18N.ns('molten.imagine.actions.ArchitectLinkAction');
const create = relationship => {
  const {
    blueprint,
    path
  } = relationship;
  return {
    id: `blueprint.action.${path}.architectLink`,
    name: tf('name', {
      blueprintName: blueprint.name
    }),
    layout: {
      sort: 'item.details'
    },
    appearance: () => ({
      name: t('appearanceName', {
        blueprintName: blueprint.name
      }),
      icon: t('icon'),
      sort: 'z'
    }),
    handles: cxt => {
      const {
        ui: {
          activePersona
        }
      } = GlobalState.get();
      const host = Config.get('architectLinkAction', 'host');
      if (activePersona?.name === 'default' && !!host) {
        return true;
      }
      return false;
    },
    perform: ({
      context
    }) => {
      const host = Config.get('architectLinkAction', 'host');
      const projectId = blueprint?.model?.projectId;
      const {
        clientProps: {
          item
        }
      } = context;
      window.open(`${host}/project/${projectId}/system/${item.systemId}/device/${item.id}/sim`);
    }
  };
};
export default {
  create
};